<template>
  <transition>
    <div v-if="isShow" name="modal">
          <div class="modal-mask">
              <div class="modal-wrapper" v-on:click="close">
                <div id="content" v-on:click.stop="">
                  <div>
                    <font-awesome-icon class="exclamation-triangle" icon="exclamation-triangle"/>
                    <div class="modal-text" v-html="message" />
                  </div>
                  <div class="ok-button" @click="ok">OK</div>
                  <span class="chancel-button" @click="close">
                    <font-awesome-icon  icon="times"/>
                  </span>
                </div>
              </div>
          </div>
    </div>
  </transition>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'

/**
 * @deprecated
 */
@Component
export default class ErrorModal extends Vue {
  private message: string = 'Error !';

  private isShow: boolean = false;

  /**
   * エラーモーダルを表示
   * @param {Error|string|string[]} message モーダルに表示するエラーメッセージ
   */
  open(message?: Error|string|string[]) {
    if (typeof message === 'string') {
      this.message = message
    }

    if (message instanceof Error) {
      this.message = message.message
    }

    if (_.isArray(message)) {
      this.message = message.join('<br />')
    }

    this.isShow = true
  }

  /**
   * モーダルを閉じる
   */
  close() {
    this.isShow = false
  }

  /**
   * OKボタン押下時
   */
  private ok() {
    this.$emit('ok')
    this.close()
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

#content{
  z-index:2;
  width:25%;
  text-align: center;
  padding: 2em;
  margin: 0 auto;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ok-button {
  background: #1cc8a0;
  border:3px solid #1cc8a0;
  color: #fff;
  padding:10px 20px;
  border-radius: 30px;
  display: block;
  width: 100px;
  margin:auto;
  cursor: pointer;
  user-select:none;
}

.ok-button:hover {
  background:#fff;
  color: #1cc8a0;
}

.chancel-button {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
}

.chancel-button:hover {
  opacity:.5;
}

.exclamation-triangle {
  color: #ee2b2b;
  font-size: 75px;
  display: block;
  margin: auto;
  margin-bottom : 20px;
}

.modal-text {
  font-size: 20px;
  margin-bottom:60px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
